export default "__VITE_ASSET__IgVcVMTA__"